import React, {useEffect} from "react";
import {FiBell, FiSettings} from "react-icons/fi";
import {IoIosArrowDown} from "react-icons/io";
import {IoCalendarOutline} from "react-icons/io5";
import {MdOutlineLogout} from "react-icons/md";
import $ from "jquery"
import {removeAuthCookies} from "../../helpers/authHelper";
import httpClient from "../../services/httpClient";
import {authApi} from "../../constans/apiUrls";
import {IAuthInfoData} from "../../contracts/data/auth";
import {generateImageLink} from "../../helpers/functions";
import {useAppSelector} from "../../hook/useAppSelector";

interface Props{
    children: React.ReactNode,
    handleOpenSidebar: any
}

const PanelMain: React.FC<Props> = ({handleOpenSidebar, children}) => {
    const date = new Date()
    const dateValue = date.toLocaleDateString("fa-IR", {
        weekday: "long",
        year: "numeric",
        day: "numeric",
        month: "long",
    }).split(',')
    const dayString = dateValue[1]
    const dateString = dateValue[0].split(' ')
    const state = useAppSelector(state => state.user)

    const handleShowUserMenu = (e:any) => {
        const tag = $('#user-menu')
        tag.slideToggle()
    }

    const handleLogOutUser = () => {
        removeAuthCookies()
        window.location.replace("/auth")
    }

    return(
        <div className="flex flex-col min-h-screen md:pr-64">
                <div className="flex justify-between h-20 items-center px-8">
                    <button className="md:hidden text-gray-500 ml-4 p-2 focus:ring-indigo-200 focus:ring-2"
                            id="sidebar-open-icon" onClick={handleOpenSidebar}>
                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                             stroke="currentColor" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                  d="M4 6h16M4 12h16M4 18h7"/>
                        </svg>
                    </button>
                    <div className="w-full">
                        <div className="flex items-center text-gray-500">
                            <div className="ml-2 text-2xl"><IoCalendarOutline /></div>
                            <div>
                                <span>{`امروز ${dayString}، `}</span>
                                <span>{`${dateString[2]} - ${dateString[1]} - ${dateString[0]}`}</span>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center">
                        <div className="pl-4 text-2xl text-gray-500 cursor-pointer">
                            <FiSettings />
                        </div>
                        <div className="pl-4 text-2xl text-gray-500 cursor-pointer">
                            <FiBell />
                        </div>
                        <div className="relative flex-shrink-0 ml-8 cursor-pointer bg-gray-300 rounded-full p-2">
                            <div className="flex items-center" onClick={handleShowUserMenu}>
                                <img className="w-8 h-8 rounded-full ml-4"
                                    src={generateImageLink(state?.avatar)}
                                    alt=""/>
                                <div className="ml-8 text-gray-500">{`${state?.first_name} ${state?.last_name}`}</div>
                                <div className="text-gray-500">
                                    <IoIosArrowDown />
                                </div>
                            </div>
                            <div id={"user-menu"} className={"hidden absolute inset-x-0 top-[55px] bg-white rounded-xl"}>
                                <ul className={"p-4"}>
                                    <li className={"flex flex-row justify-start items-center text-gray-500 text-lg cursor-pointer hover:text-blue-500"} onClick={handleLogOutUser}>
                                        <span className={"ml-2"}><MdOutlineLogout /></span>
                                        <span>خروج</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <main>
                    {children}
                </main>
            </div>
    )
}

export default PanelMain